import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import * as React from 'react'

export type SaveSuccessMessageProps = {
  children: React.ReactNode
  isVisible: boolean
}

const vanish = keyframes`
  0%    {color: var(--Success);}
  90%   {color: var(--Success);}
  100%  {color: var(--White98); display: none; visibility: hidden;}
`

const StyledSaveSuccessMessage = styled.div`
  line-height: 37px;
  color: var(--Success);
  animation: ${vanish} 3.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`

export const SaveSuccessMessage = ({ children, isVisible }: SaveSuccessMessageProps) =>
  isVisible ? <StyledSaveSuccessMessage>{children}</StyledSaveSuccessMessage> : null
